import $ from 'jquery';

export default function int_toTopPage() {
    $(".cta-to-top button").click(function(){
        $('html, body').animate({ scrollTop: 0 }, 'fast');
    })
}